import { render, staticRenderFns } from "./GoodsPurchaseList.vue?vue&type=template&id=7f274fba&scoped=true"
import script from "./GoodsPurchaseList.vue?vue&type=script&lang=js"
export * from "./GoodsPurchaseList.vue?vue&type=script&lang=js"
import style0 from "./GoodsPurchaseList.vue?vue&type=style&index=0&id=7f274fba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f274fba",
  null
  
)

export default component.exports